const s = {
  transition: "transitionend",
  WebkitTransition: "webkitTransitionEnd",
  MozTransition: "transitionend",
  OTransition: "oTransitionEnd otransitionend"
};
let o;
if (typeof document < "u") {
  const {
    style: i
  } = document.createElement("div"), n = Object.keys(s);
  for (let t = 0, e = n[t]; t < n.length; t += 1, e = n[t])
    if (e in i) {
      o = s[e];
      break;
    }
}
const r = (i, n, t) => {
  i.addEventListener(o, n);
  let e;
  return t && (e = setTimeout(() => {
    i.removeEventListener(o, n), n();
  }, t)), () => {
    clearTimeout(e), i.removeEventListener(o, n);
  };
};
export {
  r as default
};
